<div class="head">
  <h1 class="page-title">Recurring</h1>
  <span class="nut" *ngIf="!loading">{{ fmt(nutCents) }}<span class="per">/mo fixed</span></span>
</div>

<p class="loading" *ngIf="loading">Loading…</p>
<p class="error" *ngIf="error">{{ error }}</p>

<ng-container *ngIf="!loading">
  <div class="lbl">Fixed costs · {{ expenses.length }} detected</div>
  <p class="empty" *ngIf="!expenses.length">
    Nothing detected yet. A series needs three charges across three months at a steady amount.
  </p>

  <div class="row" *ngFor="let s of expenses; trackBy: trackSeries"
       [class.confirmed]="isConfirmed(s)" [class.pinned]="isPinnedSeries(s)">
    <span class="merchant">{{ s.merchant }}<span class="pin-badge" *ngIf="isPinnedSeries(s)">pinned</span></span>
    <span class="cadence">{{ s.cadence }}</span>
    <span class="next">next {{ s.nextExpected + 'T00:00:00' | date:'MMM d' }}</span>
    <span class="amt">{{ fmt(s.medianCents) }}</span>
    <span class="mo">{{ fmt(s.monthlyEquivalentCents) }}/mo</span>
    <ng-container *ngIf="!isPinnedSeries(s); else pinnedActions">
      <button class="btn" (click)="confirm(s)" [disabled]="isConfirmed(s)">
        {{ isConfirmed(s) ? '✓' : 'Confirm' }}
      </button>
    </ng-container>
    <ng-template #pinnedActions>
      <button class="link-btn" (click)="unpin(s)">unpin</button>
    </ng-template>
    <button class="link-btn dismiss-btn" (click)="dismiss(s)">dismiss</button>
  </div>

  <ng-container *ngIf="income.length">
    <div class="lbl second">Recurring income · not counted in the fixed total</div>
    <div class="row income" *ngFor="let s of income; trackBy: trackSeries">
      <span class="merchant">{{ s.merchant }}</span>
      <span class="cadence">{{ s.cadence }}</span>
      <span class="next">next {{ s.nextExpected + 'T00:00:00' | date:'MMM d' }}</span>
      <span class="amt">{{ fmt(s.medianCents) }}</span>
      <span class="mo">{{ fmt(s.monthlyEquivalentCents) }}/mo</span>
      <button class="link-btn" (click)="dismiss(s)">dismiss</button>
    </div>
  </ng-container>

  <ng-container *ngIf="stale.length">
    <div class="lbl second">No longer seen · not counted in the fixed total</div>
    <div class="row stale" *ngFor="let s of stale; trackBy: trackSeries">
      <span class="merchant">{{ s.merchant }}</span>
      <span class="cadence">{{ s.cadence }}</span>
      <span class="next">last {{ s.lastDate + 'T00:00:00' | date:'MMM d, y' }}</span>
      <span class="amt">{{ fmt(s.medianCents) }}</span>
      <span class="mo">{{ fmt(s.monthlyEquivalentCents) }}/mo</span>
      <button class="link-btn" (click)="dismiss(s)">dismiss</button>
    </div>
  </ng-container>

  <ng-container *ngIf="candidates.length">
    <div class="lbl second">Not detected</div>
    <p class="hint">These look like bills but did not meet the automatic rules.</p>
    <div class="row candidate" *ngFor="let c of candidates; trackBy: trackCandidate">
      <span class="merchant">{{ c.merchant }}</span>
      <span class="cadence">{{ c.reason }}</span>
      <span class="next">{{ c.occurrences }}×/{{ c.months }}mo</span>
      <span class="amt">{{ fmt(c.medianCents) }}</span>
      <span class="mo"></span>
      <button class="btn" (click)="pin(c.key)">Add</button>
      <button class="link-btn dismiss-btn" (click)="dismissCandidate(c.key)"
              title="Not a recurring expense">×</button>
    </div>
  </ng-container>

  <ng-container *ngIf="dismissed.length">
    <button class="link-btn toggle-dismissed" (click)="toggleDismissed()">
      {{ dismissed.length }} dismissed
    </button>
    <ng-container *ngIf="showDismissed">
      <div class="row dismissed" *ngFor="let e of dismissed; trackBy: trackDismissed">
        <span class="merchant">{{ e.merchant }}</span>
        <span class="cadence">{{ e.wasDetected ? 'detected' : 'not detected' }}</span>
        <span class="amt"></span>
        <span class="mo">{{ fmt(e.monthlyCents) }}/mo</span>
        <button class="link-btn" (click)="restore(e)">Restore</button>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
